import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1;
  min-width: 100%;
`
